const code = {
  MSMC1302: 'Wrong email format, please check it out',
  MSMC1303: 'Sorry the email is not registered',
  MSMC1304: 'Verification code is required',
  MSMC1305: 'Incorrect verification code',
  MSMC1306: 'The password must consist of 6 to 20 digits and English',
  MSMC1307: 'Two passwords are different',
  MSMC1308: 'The minimum withdrawal amount is 500$',
  MSMC1309: 'Order does not exist',
  MSMC1310: 'The organization does not exist',
  MSMC1311: 'This email has been registered',
  MSMC1317: 'This email has been registered',
  MSMC1318: 'This link has binded with the activity',
  MSMC1319: 'This link has expired',
  MSMC1320: 'Login email is required',
  MSMC1322: 'Link has expired',
  MSMC1324: 'This event does not exist',
  MSMC1325: 'Event has been deleted',
  MSUW0137: 'Sorry, the login email or password is incorrect',
  MSUW0102: 'Sorry, the login email or password is incorrect',
}

export default code
